module.exports = require('./dist/bundle.js');




//////////////////
// WEBPACK FOOTER
// ./~/re-base/index.js
// module id = 32
// module chunks = 0